import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Profile.css';  // Make sure to import the Profile CSS

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  // Fetch user details after the component mounts
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')); // Get user data from localStorage
    const id = user?.id; // Get userId from localStorage

    if (!id) {
      setErrorMessage('User not logged in');
      navigate('/login'); // Redirect to login if no userId found
    } else {
      // Fetch the user profile from the backend using the userId
      fetchUserProfile(id);
    }
  }, [navigate]);

  // Function to fetch user profile by userId
  const fetchUserProfile = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/${userId}`); // Fetch user by userId
      setUserDetails(response.data); // Save the user details in the state
      setLoading(false); // Stop loading once the data is fetched
    } catch (error) {
      console.error('Error fetching profile:', error);
      setErrorMessage('Failed to fetch user details');
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="container-profile">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      {userDetails && (
        <div className="profile">
          <h2 className="text-center mb-4" style={{ color: 'red' }}>Profile</h2>
          <table className="profile-table">
            <tbody>
              <tr>
                <td><strong>Display Name</strong></td>
                <td>{userDetails.fullname}</td>
              </tr>
              <tr>
                <td><strong>User Name</strong></td>
                <td>{userDetails.username}</td>
              </tr>
              <tr>
                <td><strong>Email</strong></td>
                <td>{userDetails.email}</td>
              </tr>
              <tr>
                <td><strong>Employee ID</strong></td>
                <td>{userDetails.employeeId}</td>
              </tr>
              <tr>
                <td><strong>Phone Number</strong></td>
                <td>{userDetails.mobileNum}</td>
              </tr>
              <tr>
                <td><strong>Designation</strong></td>
                <td>{userDetails.designation}</td>
              </tr>
              {/* <tr>
                <td><strong>Role</strong></td>
                <td>{userDetails.roleName}</td>
              </tr>
              <tr>
                <td><strong>District</strong></td>
                <td>{userDetails.districtName}</td>
              </tr>
              <tr>
                <td><strong>SubDivision</strong></td>
                <td>{userDetails.subDivisionName}</td>
              </tr>
              <tr>
                <td><strong>Block</strong></td>
                <td>{userDetails.blockName}</td>
              </tr> */}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Profile;
